import { GoogleStars, Text } from '@belong/ui';
import clsx from 'clsx';
import { AUTH_STRINGS } from 'src/features/auth/strings';
import css from './benefits-animated-vertical-slider.module.css';

const BENEFITS = [
  AUTH_STRINGS['benefit.vacancy'],
  AUTH_STRINGS['benefit.payments'],
  AUTH_STRINGS['benefit.care'],
  AUTH_STRINGS['benefit.inspection'],
  AUTH_STRINGS['benefit.pricing'],
];

export function BenefitsAnimatedVerticalSlider() {
  return (
    <div className={clsx('overflow-hidden', css.container)}>
      <ul className={clsx('list-none', css.list)}>
        <li className={clsx('flex items-center justify-center', css.item)}>
          <GoogleStars />
        </li>
        {BENEFITS.map((benefit, index) => (
          <li
            className={clsx('flex items-center justify-center', css.item)}
            key={index}
          >
            <Text as="h2" fontWeight="semibold" variant="h3">
              {benefit}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
}
